import Vue from 'vue'
import axios from 'axios'

let baseUrl = process.env.NODE_ENV === 'production' ? 'https://fulfillment.printbelle.com/prod_api' : '/dev_api'
// 设置axios的基础请求路径
axios.defaults.baseURL = baseUrl
axios.defaults.withCredentials = true
axios.loadData = async function (url) {
  const resp = await axios.get(url)
  return resp.data
}
// 将axios添加到 Vue的原型，这样一切vue实例都可以使用该对象
Vue.prototype.$http = axios



// WEBPACK FOOTER //
// ./src/http.js